module.exports = __webpack_public_path__ + "img/08_Howto-3.d2c7772d.jpg";